import { configureRequest } from '../../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  GetLockerOrderDetailsErrorResponse,
  GetLockerOrderDetailsRequest,
  GetLockerOrderDetailsSuccessResponse
} from './getLockerOrderDetails.types'

export const getLockerOrderDetailsApi = async (
  request: GetLockerOrderDetailsRequest
): Promise<GetLockerOrderDetailsSuccessResponse> => {
  const url = urls.admin.getLockerOrderDetails.replace(':boxId', request.boxId)

  const response = await configureRequest({
    url,
    method: 'GET',
    headers: {
      'X-User-Role': UserRole.admin
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as GetLockerOrderDetailsSuccessResponse
  } else {
    throw response as GetLockerOrderDetailsErrorResponse
  }
}

export default getLockerOrderDetailsApi
